import React from "react";
import { isPositiveStatus } from "../../utils";
import styles from "./systemHealth.module.css";

type StatusPillProps = {
  status?: string | boolean;
  upLabel?: string;
  downLabel?: string;
};

const StatusPill: React.FC<StatusPillProps> = ({
  status,
  upLabel,
  downLabel,
}) => {
  const positive =
    typeof status === "boolean" ? status : isPositiveStatus(status);
  const label =
    typeof status === "boolean"
      ? positive
        ? upLabel || "Yes"
        : downLabel || "No"
      : positive
        ? upLabel || "Up"
        : downLabel || status || "Unknown";

  return (
    <span
      className={`${styles.statusPill} ${
        positive ? styles.statusPillUp : styles.statusPillDown
      }`}
    >
      <span className={styles.statusDot} />
      {label}
    </span>
  );
};

export default StatusPill;
